import NumberFormatter from './NumberFormatter';

/**
 * Class LocaleFormatter it's Facade of different formatting classes.
 */
class LocaleFormatter {
	static number(value) {
		return NumberFormatter.getInstance().numberFormatter.format(value);
	}

	static currency(value, options = {noFraction: false}) {
		if (options.noFraction) {
			return NumberFormatter.getInstance().currencyFormatterNoFraction.format(value);
		} else {
			return NumberFormatter.getInstance().currencyFormatter.format(value);
		}
	}

	static parseFormattedNumber(stringNumber) {
		return NumberFormatter.getInstance().parseFormattedNumber(stringNumber);
	}

	static getCleaveCurrencyNumberOptions() {
		const currencyOptions = NumberFormatter.getInstance().currencyOptions;

		const cleaveNumberOptions = {
			numeral: true,
			numeralDecimalScale: 2,
			delimiter: currencyOptions.thousands_separator,
		};

		return cleaveNumberOptions;
	}
}

export default LocaleFormatter;
